import { memo, Suspense, useState } from 'react'
import api from 'services/api'
import { Outlet } from 'react-router-dom'
import { useDispatch, useSelector } from 'store/store'
import { handleLogout } from 'store/AuthContext/authSlice'
import { CircularProgress, Modal } from 'components'
import {
  useInterceptors,
  UseInterceptorsInterface
} from 'commons/customHooks/useInterceptors'
import { asyncLocalStorage } from 'components'
import {
  setConfirmedNavigation,
  setShowPrompt
} from 'store/StructuralContext/structuralSlice'
import axios from 'axios'

function Main() {
  const {
    serverErrorModal,
    setServerErrorModal,
    timeoutTime,
    modalTitleErrorMessage,
    setModalTitleErrorMessage,
    modalMessage,
    setModalMessage
  }: UseInterceptorsInterface = useInterceptors()

  const dispatch = useDispatch()
  const { showPrompt } = useSelector(({ structure }) => structure)
  const [allowModal, setAllowModal] = useState<boolean>(true)

  api.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      const localStorageError = localStorage.getItem('serverErrorModal')
      setAllowModal(true)

      //request canceled by system
      if (axios.isCancel(error)) {
        return Promise.reject(error)
      }

      if (
        // email related to others profiles
        error.response.data.return_code === 6012 ||
        // email or password incorrect
        error.response.data.return_code === 6010 ||
        // code expired
        error.response.data.return_code === 6011 ||
        // new password is the same as the old one
        error.response.data.return_code === 512 ||
        error.response.config?.url?.includes('upload-planilha')
      ) {
        // Don`t handle with modal error in this case
        return Promise.reject(error)
      }

      // NOTE: Handle response error when response data is an error array
      if (error.response && error.response.data instanceof Array) {
        return Promise.reject(error)
      }

      if (!serverErrorModal && !localStorageError && allowModal) {
        if (error.response?.status === 401) {
          asyncLocalStorage.removeItem('token').then(() => {
            dispatch(handleLogout())
          })

          setAllowModal(false)
          localStorage.setItem(
            'serverErrorModalMessage',
            JSON.stringify({
              title: 'Login expirado.',
              message: 'Por favor, faça seu login novamente.'
            })
          )
        } else if (error.response) {
          const message =
            error.response.data.return_chav ??
            error.response.data.message ??
            error.response.data?.MensagemRetorno ??
            error.response.data?.errors[0]?.message
          localStorage.setItem('serverErrorModalMessage', JSON.stringify({ message }))
        }
        localStorage.setItem('serverErrorModal', JSON.stringify({ open: true }))
        setTimeout(() => {
          localStorage.removeItem('serverErrorModal')
        }, timeoutTime)
      }
      if (localStorageError && allowModal) {
        localStorage.setItem('serverErrorModal', JSON.stringify({ open: true }))
      }
      return Promise.reject(error)
    }
  )

  const handleErrorModalClose = () => {
    setServerErrorModal(false)
    localStorage.removeItem('serverErrorModal')
    localStorage.removeItem('serverErrorModalMessage')
    setModalTitleErrorMessage('...')
    setModalMessage('...')
    setAllowModal(true)
  }

  return (
    <>
      <Suspense fallback={<CircularProgress isRoute />}>
        <Outlet />
        {allowModal && (
          <Modal
            title={modalTitleErrorMessage || ''}
            description={modalMessage || ''}
            open={serverErrorModal || false}
            setOpen={setServerErrorModal}
            closeAction={handleErrorModalClose}
            buttonAction={handleErrorModalClose}
          />
        )}
        <Modal
          open={showPrompt}
          setOpen={(isOpen) => dispatch(setShowPrompt(isOpen))}
          title="Continuar de onde parou"
          description="Existem campos que não foram salvos, deseja prosseguir mesmo assim?"
          showReturn
          returnIcon={<></>}
          returnText="DESCARTAR O PROGRESSO"
          buttonText="CONTINUAR A EDIÇÃO"
          buttonAction={() => dispatch(setShowPrompt(false))}
          returnAction={() => {
            dispatch(setShowPrompt(false))
            dispatch(setConfirmedNavigation(true))
          }}
        />
      </Suspense>
    </>
  )
}

export default memo(Main)
